<template>
  <div class="dashboard_container">

    <Header />
    
    <div class="main_container">

      <!-- <div class="main_site" @click="handleCustomerRoute" v-if="$store.state.role == 'ROOT'">
        <img src="../assets/customer.png" alt="customer">
        <div>Manage</div>
      </div>
      <div class="main_site" @click="handleDashRoute" v-if="accessRight">
        <img src="../assets/dashboard.png" alt="dashboard">
        <div>DashBoard</div>
      </div>
      <div class="main_site" v-for="(data,index) in sites" :key="index" @click="handleSiteRoute(data._id)">
          <img :src="data.smallImage || data.mediumImage || data.originalImage" :alt="data.name">
          <div>{{data.name}}</div>
      </div> -->
      <div class="card_container">
        <!-- <img src='../assets/logo_sprc.svg' style="height:100px,max-width:100px"/> -->
        <img src='../assets/user_edit.svg' class="main_img" />
        <div class="main_title">LIST SITES</div>
        <div style="margin-bottom:32px;margin-top:8px">Total sites: {{sites.length}}</div>
        <div class="select_container" v-for="(data,index) in sites" :key="index" @click="handleSiteRoute(data._id)">
          <div class="item_container">
            <span>Site {{data.name}}</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
        </div>
      </div>

      <!-- <div class="card_container">
        <img src='../assets/user_edit.svg' class="main_img" />
        <div class="main_title" style="margin-bottom:32px">PROFILE INFORMATION</div>
        <div class="select_container">
          <div class="item_container">
            <span>Change email address</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
        <div class="select_container">
          <div class="item_container">
            <span>Update registration information</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
        <div class="select_container">
          <div class="item_container">
            <span>Change password</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
      </div> -->
      
      <div class="card_container" v-if="this.$store.state.role=='ROOT'">
        <img src='../assets/manager.svg' class="main_img"/>
        <div class="main_title" style="margin-bottom:32px">MANAGEMENT</div>
        <div class="select_container" @click="handleCustomerAdmin">
          <div class="item_container">
            <span>User Management</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
        <div class="select_container" @click="handleCustomerSystem">
          <div class="item_container">
            <span>System Management</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
        <div class="select_container" @click="handleCustomerSite">
          <div class="item_container">
            <span>Site Management</span>
            <img src='../assets/right.svg' style="width:16px;height:16px"/>
          </div>
          <div class="break_line"></div>
          
        </div>
      </div>
    </div>
    <Footer></Footer>
    
  </div>
</template>
<script>
import Footer from '../components/Footer'
import request from '@/utils/request'
import tokenUtils from '../utils/token'
import Header from '../components/Header'
export default {
  name:'Home',
  components:{
    Footer,
    Header,
  },
  created() {
    // console.log(this.$store.state)
    request('get', '/sites')
      .then(data => {
        this.sites = data.sites
      })
      .catch(err => console.log(err))
  },
  data(){
    return{
      customerInfo: null,
      sites: [],
    }
  },
  computed:{
    accessRight(){
      let roleRight=['ROOT','CUSTOMER','MASTER'];
      return roleRight.includes(this.$store.state.role)
    }
  },
  methods:{
    handleCustomerAdmin(){
      this.$router.push('/customer/home')
    },
    handleCustomerSystem(){
      this.$router.push('/customer/system')
    },
    handleCustomerSite(){
      this.$router.push('/customer/site')
    },
    handleSiteRoute(_id) {
      if(this.accessRight){
        this.$router.push(`/site/${_id}/dashboard`)
      }
      else{
        this.$router.push(`/site/${_id}/psm`)
      }
      
    },
    // handleDashRoute(){
    //   this.$router.push('/dashboard/')
    // },
    logout(){
      tokenUtils.remove();
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
  .dashboard_container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100vh;
    --textColor:#6D6E71;
    background-color: #ECECEC;
  }
  .main_container{
    position: relative;
    z-index: 1;
    margin-top:150px;
    display: flex;
    flex-direction: row;
    
    justify-content: space-evenly;

    width: 80%;
    .card_container{    
      padding: 24px;
      width: 30%;
      background-color: white;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-left:24px;
      margin-right: 24px;
      cursor: pointer;
      .main_img{
        width:100px;
        height:100px;
        
        
        
      }
      
     .main_title{
        font-size: 1.2rem;
        color:#0080F6;
        margin-top:16px;
        font-weight: bold;
      }
      .select_container{
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 8px;
        .item_container{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 8px;
        }
        .break_line{
          height: 1px;
          width:100%;
          background-color: #D0D0D0;
        }
      }
      .select_container:hover{
        color:#0080F6;
      }


    }
    .card_container:hover{
     box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    }

  }


</style>